// extracted by mini-css-extract-plugin
module.exports = {"animated-headline":"AnimatedHeadline_animated-headline__f52tB","pause-btn":"AnimatedHeadline_pause-btn__xXoyp"};